import eventError from '../../assets/images/error.png';
import './oops.scss';
import cn from 'classnames';

type OopsProps = Partial<{
  title: string;
  desc: string;
  className?: any;
}>;

function OopsComponent({
  title = 'Oops!',
  desc = 'There is no space',
  className,
}: OopsProps) {
  return (
    <div
      className={cn('searchErrorContainer', {
        [className]: !!className,
      })}
    >
      <div className="searchErrorImage">
        <img src={eventError} alt="error" className="searchErrorImg" />
      </div>
      <p className="searchErrorTitle">{title}</p>
      <p className="searchErrorMessage">{desc}</p>
    </div>
  );
}

export default OopsComponent;
